export default __webpack_public_path__ + "static/media/play.93c28767.svg";